module.exports = __webpack_public_path__ + "media/img/careers/vacancies-bg-icon-2b80db4ebb1a46f130fda420047e5ba1.svg";